/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Adminbypassenable2Inputs */

const en_adminbypassenable2 = /** @type {(inputs: Adminbypassenable2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enable bypass`)
};

const de_adminbypassenable2 = /** @type {(inputs: Adminbypassenable2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bypass aktivieren`)
};

/**
* | output |
* | --- |
* | "Enable bypass" |
*
* @param {Adminbypassenable2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const adminbypassenable2 = /** @type {((inputs?: Adminbypassenable2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Adminbypassenable2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_adminbypassenable2(inputs)
	return de_adminbypassenable2(inputs)
});
export { adminbypassenable2 as "adminBypassEnable" }